/**
 * Hold shared logics
 */
import ethIcon from './images/ETH.svg';
import bscIcon from './images/BSC.png';
import avaxIcon from './images/AVAX.svg';
import hecoIcon from './images/HECO.svg';
import polygonIcon from './images/POLYGON.svg';
import tronIcon from './images/TRON.png';
import bttcIcon from './images/BTTC.svg';
import ftmIcon from './images/FTM.svg';
import egldIcon from './images/EGLD.svg';
import bnbIcon from './images/BNB.svg';
import { Network } from '@kattana-io/common';

interface INetworkBaseCoinIconProps {
  network: Network | undefined;
  className: string;
  motherTokenStyle: any;
}

export const IconsMapping: any = {
  ETH: ethIcon,
  BSC: bscIcon,
  AVAX: avaxIcon,
  HT: hecoIcon,
  MATIC: polygonIcon,
  FTM: ftmIcon,
  BTTC: bttcIcon,
  EGLD: egldIcon,
  BNB: bnbIcon,
};

const NetworkBaseCoinIcon = (props: INetworkBaseCoinIconProps) => {
  const { network, className, motherTokenStyle } = props;
  if (network) {
    // Check if it is a Tron
    if (network?.isTron()) {
      return (
        <img
          src={tronIcon}
          className={`currency__icon ${className ? className : ''}`}
          style={motherTokenStyle}
        />
      );
    }
    // Try mapping
    const mapping = IconsMapping[network.getSymbol() as string];
    if (mapping) {
      return (
        <img
          src={mapping}
          className={`currency__icon ${className ? className : ''}`}
          style={motherTokenStyle}
        />
      );
    }
    return null;
  } else {
    return null;
  }
};

export default NetworkBaseCoinIcon;
